module.exports = __webpack_public_path__ + "img/ballot-check.2acfad7e.svg";